export default "<p>\n  If you are not redirected automatically,\n  <a (click)=\"goToDeep()\" class=\"text\">click here</a>\n</p>\n"